import { Suspense, lazy } from 'react'

import CasinoLayoutSkeleton from '../Casino/CasinoLayoutSkeleton'
import { useIsCasinoLiteMode } from '../../hooks/useIsCasinoLiteMode'
import { lazyRetry } from '../../services/utils'

const CasinoNormal = lazy(() => lazyRetry(() => import('./../../H5G'), 'casinoComponent'))
const CasinoLite = lazy(() =>
  lazyRetry(() => import('./../../components/CasinoLite/SweepsWrapper'), 'casinoLiteComponent')
)

export const InitMode = () => {
  const { isCasinoLiteMode } = useIsCasinoLiteMode()

  return <Suspense fallback={<CasinoLayoutSkeleton />}>{isCasinoLiteMode ? <CasinoLite /> : <CasinoNormal />}</Suspense>
}
